import axios from 'axios'
import { pixabayConfig } from '../config'
import _ from 'lodash'
export default class Pixabay {
  static propTypes = {}
  constructor(apiKey = pixabayConfig.key) {
    this.apiKey = apiKey
    this.width = 170
    this.height = 128
    this.per_page = 25
  }

  getImages = (q = 'places', page = 1) => {
    let URL =
      'https://pixabay.com/api/?key=' +
      this.apiKey +
      '&q=' +
      encodeURIComponent(q) +
      `&per_page=${this.per_page}&orientation=horizontal&page=${page}`
    return axios
      .get(URL)
      .then((resp, reject) => {
        if (resp) {
          return resp.data.hits
        } else {
          return { error: reject }
        }
      })
      .catch(err => {
        return { error: err }
      })
  }
}



// WEBPACK FOOTER //
// src/libs/pixabay.js